// https://stackoverflow.com/a/60564620
export function getNodeText(node: React.ReactNode): string {
  if (node === null) return "";

  switch (typeof node) {
    case "string":
    case "number":
      return node.toString();

    case "boolean":
      return "";

    case "object": {
      if (Array.isArray(node)) return node.map(getNodeText).join("");

      if ("props" in node)
        return getNodeText(
          (node.props as { children?: React.ReactNode }).children
        );
      return "";
    }

    default:
      return "";
  }
}
